import { useEffect } from "react";

import { Outlet } from "react-router";

import { ActivityType } from "__graphql__/types";
import { usePublishActivityStatusChanged } from "flows/Activities/hooks/usePublishActivityStatusChanged";

type ActivityRouteTrackerProps = {
  activityType: ActivityType;
};

export function ActivityRouteTracker({ activityType }: ActivityRouteTrackerProps) {
  const { publishActivityStatusStart, publishActivityStatusEnd } =
    usePublishActivityStatusChanged(activityType);

  useEffect(() => {
    publishActivityStatusStart();
    return () => {
      publishActivityStatusEnd();
    };
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Outlet />;
}
